export const services = [
  {
    id: 1,
    title: "Carpet Steam Cleaning in Calgary",
    description: "Deep cleaning for homes using eco-friendly products. Remove stains, allergens, and odors to restore your carpets to like-new condition.",
    features: ["Deep steam cleaning", "Hot water extraction", "Odor elimination", "Fast drying"]
  },
  {
    id: 2,
    title: "Commercial Carpet Cleaning",
    description: "Professional carpet cleaning for offices, restaurants, and businesses. Keep your commercial space looking pristine and professional.",
    features: ["Flexible scheduling", "Minimal disruption", "High-traffic solutions", "Volume discounts"]
  },
  {
    id: 3,
    title: "Pet Stain Removal in Calgary",
    description: "Specialized treatment for pet stains and odors. Advanced enzyme solutions that eliminate pet accidents and restore your carpets.",
    features: ["Pet urine removal", "Odor neutralization", "Safe for pets & kids", "Guaranteed results"]
  },
  {
    id: 4,
    title: "Upholstery Cleaning in Calgary",
    description: "Refresh your furniture with professional upholstery cleaning. Extends the life of your couches, chairs, and other fabric furnishings.",
    features: ["Fabric-safe cleaning", "Deodorizing", "Stain protection"]
  },
  {
    id: 5,
    title: "Mattress Cleaning",
    description: "Deep cleaning and sanitization of mattresses to remove dust mites, allergens, and bacteria for a healthier sleep environment.",
    features: ["Deep sanitization", "Stain treatment", "Odor elimination"]
  },
  {
    id: 6,
    title: "Area Rug Cleaning",
    description: "Specialized cleaning for all types of area rugs including Persian, Oriental, and modern rugs. Preserves colors and fibers.",
    features: ["On-site cleaning", "Color-safe methods", "Protective treatments"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah M., NW Calgary",
    content: "I had terrible pet stains on my living room carpet that I thought were permanent. Carpex came the same day I called and completely removed them. Amazing results and very professional team. Highly recommend to any Calgary pet owner!",
    rating: 5
  },
  {
    id: 2,
    name: "David S., Okotoks",
    content: "Had my 3 seater sofa and carpet cleaned by Carpex. Both look absolutely brand new. The technician was friendly, careful and very professional. Best carpet cleaning company in Calgary by far!",
    rating: 5
  },
  {
    id: 3,
    name: "Raj P., NE Calgary",
    content: "Got quotes from 3 companies and Carpex had the best price with no hidden fees. The quality of cleaning was exceptional. My carpets have never looked this clean. Great value for money in Calgary!",
    rating: 5
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_spotless-floors-4/artifacts/u1feprud_WhatsApp%20Image%202026-02-13%20at%207.11.58%20PM.jpeg",
    alt: "Carpet before professional cleaning - showing dirt and stains",
    type: "before"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_spotless-floors-4/artifacts/zj0a41pv_WhatsApp%20Image%202026-02-13%20at%207.11.58%20PM%20%281%29.jpeg",
    alt: "Carpet after professional cleaning - fresh and clean",
    type: "after"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_spotless-floors-4/artifacts/o7idji3a_WhatsApp%20Image%202026-02-21%20at%203.04.08%20PM.jpeg",
    alt: "Professional carpet cleaning result",
    type: "after"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1742483359033-13315b247c74",
    alt: "Professional carpet cleaning in bright modern living room with natural sunlight",
    type: "process"
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1631679706909-1844bbd07221",
    alt: "Bright modern luxury living room with pristine white carpet",
    type: "after"
  },
  {
    id: 6,
    url: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92",
    alt: "Modern living room with natural sunlight and clean carpet",
    type: "after"
  },
  {
    id: 7,
    url: "https://images.unsplash.com/photo-1675756544970-968f9e3f7ca5",
    alt: "Clean living room with pristine carpet after professional cleaning",
    type: "after"
  },
  {
    id: 8,
    url: "https://images.unsplash.com/photo-1616450088319-ff2ea6e7cc68",
    alt: "Professional carpet cleaning in progress",
    type: "process"
  }
];

export const companyInfo = {
  name: "Carpex Cleaning Services",
  tagline: "Professional Carpet Cleaning Services",
  phone: "(825) 583-7478",
  email: "infocarpexcleaning@gmail.com",
  hours: "Mon-Sun: 8AM - 6PM",
  logo: "https://customer-assets.emergentagent.com/job_352e178d-0689-4f67-b283-3a4e17845005/artifacts/4c67c77j_Blue%20Modern%20Home%20Cleaning%20Logo%20%281%29.png",
  socialMedia: {
    facebook: "https://www.facebook.com/profile.php?id=61586955816456",
    instagram: "https://www.instagram.com/carpexcleaning",
    yelp: "https://www.yelp.ca/biz/carpex-cleaning-services-calgary",
    google: "https://maps.app.goo.gl/fe2yRovKWUJhRqxd6"
  }
};

export const whyChooseUs = [
  {
    id: 1,
    title: "Experienced Professionals",
    description: "Our trained technicians deliver exceptional results using industry-leading techniques and equipment."
  },
  {
    id: 2,
    title: "Eco-Friendly Products",
    description: "We use environmentally safe cleaning solutions that are tough on stains but gentle on your carpets and family."
  },
  {
    id: 3,
    title: "100% Satisfaction Guaranteed",
    description: "If you're not completely satisfied with our service, we'll make it right. Your satisfaction is our priority."
  },
  {
    id: 4,
    title: "Flexible Scheduling",
    description: "We work around your schedule with same-day and after-hours service options available."
  }
];

export const serviceAreas = [
  "Downtown Calgary", "Southwest Calgary", "Southeast Calgary", "Northwest Calgary", "Northeast Calgary",
  "Auburn Bay", "Eau Claire", "Shawnessy", "McKenzie Towne", "Chinatown",
  "West Springs", "Mahogany", "Mission", "Alpine Park", "Seton",
  "Yorkville", "Sirocco", "Legacy", "Trinity Hills", "Pine Creek",
  "Walden", "Macleod", "Barlow", "Anderson", "Deerfoot",
  "Canyon Meadows", "Spruce Meadows", "Foothills", "Chestermere", "Quarry Park",
  "Okotoks", "High River", "Fish Creek", "De Winton", "Janet",
  "Glenmore", "Altadore", "Roxboro", "Patterson", "Beltline",
  "Rideau Park", "Mount Royal", "Britannia", "Parkhill", "Belvedere",
  "West End", "Aspen Woods", "Cranston", "East Village", "Evergreen",
  "And More..."
];

export const faqs = [
  {
    question: "How long does carpet cleaning take?",
    answer: "Most homes take between 1-3 hours depending on the number of rooms and condition of carpets. We work efficiently without compromising on quality."
  },
  {
    question: "How soon can I walk on my carpets after cleaning?",
    answer: "Your carpets will be dry and ready to walk on within 4-6 hours. Our low-moisture technique means faster drying times than traditional methods."
  },
  {
    question: "Are your cleaning products safe for kids and pets?",
    answer: "Absolutely! We use 100% eco-friendly, non-toxic, and pet-safe products. Your family and pets can enjoy freshly cleaned carpets without any health concerns."
  },
  {
    question: "Do you move furniture before cleaning?",
    answer: "We move light furniture such as chairs and small tables. We recommend moving heavy furniture like sofas and beds before our arrival for best results."
  },
  {
    question: "Do you offer same day carpet cleaning in Calgary?",
    answer: "Yes! We offer same day service subject to availability. Call us in the morning and we can often be at your home the same day."
  },
  {
    question: "What areas in Calgary do you serve?",
    answer: "We serve all Calgary neighbourhoods including Downtown, NW, NE, SW, SE Calgary, and surrounding areas including Airdrie, Chestermere, Okotoks, and more."
  },
  {
    question: "How do I book a carpet cleaning appointment?",
    answer: "Booking is easy! Call or text us at (825) 583-7478, email us at infocarpexcleaning@gmail.com, or fill out the contact form on our website. We respond within 1 hour!"
  },
  {
    question: "Do you clean commercial carpets?",
    answer: "Yes! We offer commercial carpet cleaning for offices, schools, restaurants and other businesses in Calgary. Contact us for a custom commercial quote."
  },
  {
    question: "What is your satisfaction guarantee?",
    answer: "We offer 100% satisfaction guarantee. If you are not happy with our cleaning we will return and re-clean the area for free. That is our promise to every Calgary customer."
  }
];

export const pricingCategories = [
  {
    title: "Carpet Cleaning",
    headerClass: "bg-gradient-to-r from-cyan-700 to-cyan-600",
    items: [
      { name: "2 Rooms (upto 200 sq ft)", price: "$99" },
      { name: "3 Rooms (upto 200 sq ft)", price: "$125" },
      { name: "Staircase (up to 15 steps)", price: "$50" },
      { name: "Hallway", price: "$20" },
      { name: "Walk-in Closet", price: "$20" }
    ]
  },
  {
    title: "Upholstery Cleaning",
    headerClass: "bg-gradient-to-r from-emerald-700 to-emerald-600",
    items: [
      { name: "Ottoman", price: "$50" },
      { name: "Dining Chair", price: "$20" },
      { name: "Arm Chair", price: "$60" },
      { name: "Sofa 2 Seater", price: "$85" },
      { name: "Sofa 3 Seater", price: "$110" }
    ]
  },
  {
    title: "Mattress Cleaning",
    headerClass: "bg-gradient-to-r from-indigo-700 to-indigo-600",
    items: [
      { name: "Single/Twin Mattress", price: "$60" },
      { name: "Double/Queen Mattress", price: "$85" },
      { name: "King Mattress", price: "$110" }
    ],
    note: "Includes sanitization & deodorizing"
  },
  {
    title: "Area Rug & Specialty",
    headerClass: "bg-gradient-to-r from-violet-700 to-violet-600",
    items: [
      { name: "Small Rug (up to 60 sq ft)", price: "$60" },
      { name: "Medium Rug (up to 90 sq ft)", price: "$85" },
      { name: "Large Rug (up to 180 sq ft)", price: "$110" },
      { name: "Commercial Cleaning", price: "Custom Quote" }
    ]
  }
];